"use client";

import { Box, BoxProps } from "@mui/material";
import { memo } from "react";

const AppHTMLRender = ({ htmlRender, ...otherProps }: AppHTMLRenderProps) => {
  return (
    <Box
      sx={{
        width: "100%",
        "& p": {
          margin: "revert",
        },

        "& table": {
          boxSizing: "border-box",
          borderCollapse: "1px solid black",
        },

        "& td": {
          borderWidth: "1px",
          border: "1px solid black",
          minWidth: "50px",
        },
      }}
      dangerouslySetInnerHTML={{
        __html: htmlRender,
      }}
      {...otherProps}
    />
  );
};

export default memo(AppHTMLRender);

type AppHTMLRenderProps = BoxProps & {
  htmlRender: string | TrustedHTML;
};
